import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TipiArticoliService {
  private http = inject(HttpClient);

  tipiArticoliUrl = environment.ildatoArticoliDpi + 'api/tipiarticoli';

  private _listTipiArticoliTempSubject = new BehaviorSubject<TipiArticoli[] | undefined>(
    undefined
  );

  list(): Observable<TipiArticoli[]> {
    return this.http.get<TipiArticoli[]>(`${this.tipiArticoliUrl}`);
  }

  listByMansione(idMansione: number): Observable<TipiArticoli[]> {
    return this.http.get<TipiArticoli[]>(
      `${this.tipiArticoliUrl}/byMansione/${idMansione}`,
    );
  }

  get(id: number): Observable<TipiArticoli> {
    return this.http.get<TipiArticoli>(`${this.tipiArticoliUrl}/${id}`);
  }

  post(values: TipiArticoli): Observable<TipiArticoli> {
    return this.http.post<TipiArticoli>(`${this.tipiArticoliUrl}`, values);
  }

  update(key: number, values: TipiArticoli): Observable<TipiArticoli> {
    return this.http.put<TipiArticoli>(
      `${this.tipiArticoliUrl}/${key}`,
      values,
    );
  }

  remove(key: number): Observable<TipiArticoli> {
    return this.http.delete<TipiArticoli>(`${this.tipiArticoliUrl}/${key}`);
  }

  getListTipiArticoliTemp(forceRefresh = false): Observable<TipiArticoli[]> {
    if (
      this._listTipiArticoliTempSubject.value == undefined ||
      forceRefresh
    ) {
      this.http.get<TipiArticoli[]>(this.tipiArticoliUrl).subscribe({
        next: (res) => {
          this._listTipiArticoliTempSubject.next(res);
        },
        error: (error) => {
          console.log('Errore caricamento tipi articoli temp: ' + error);
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore caricamento tipi articoli temp', 'warning');
          }
        },
      });
    }
    return this._listTipiArticoliTempSubject
      .asObservable()
      .pipe(filter((r) => r != undefined));
  }

  cleanTemp(){
    this._listTipiArticoliTempSubject.next(undefined);
  }
}
